<template>
    <div>
        <staffLoginModal :settings="staffLogInModalSettings"
        style="z-index: 10;"></staffLoginModal>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapState} from 'vuex';
import staffLoginModal from "@/components/widgets/staffLogInModal";

export default {
    mixins: [mixin, errorMixin],
    components: {
        staffLoginModal,
    },
    data() {
        return {
            customModalSettings: {},
            staffLogInModalSettings: {
                show: true,
                hideOnClickOutside: false,
                question_uid: this.$route.params.questionId,
                onGotUserCreds: () => {
                    this.gotCreds()
                },
            },
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    async mounted() {
        if(this.accessToken) {
            this.navigateToSL()
        }
    },
    methods: {
        ...mapActions({}),
        gotCreds() {
            console.log(`gotCreds`)
            this.navigateToSL()
        },
        navigateToSL() {
            console.log(`navigateToSL`)
            window.location.replace(`${location.origin}/r/sl/${this.$route.params.questionId}`)
        },
    }

}
</script>

<style>

</style>
<style scoped>

</style>
